import LogoN54Primary from "../Img/logo-n54-primary.svg"


function Navbar() {
    return (
        <>
            
            <a href="https://wa.me/524612284007" class="whatsapp-btn" target="_blank"> <i class="bi bi-whatsapp"></i></a>

            <nav className="py-3 bg-F7F7F7">
                <div className="container">
                    <small>Contactános: 46 26 23 02 28 | 46 1228 4007</small>
                </div>
            </nav>
            <nav class="navbar navbar-expand-lg py-4 border-0">
                <div class="container">
                    <a class="navbar-brand" href="/"><img className="logo-responsive" src={LogoN54Primary} width={250} alt="Logotipo" /></a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link" aria-current="page" href="/">Inicio</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/nosotros">Nosotros</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/servicios">Servicios</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/contacto">Contacto</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/barra-de-abogados">Barra de Abogados</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">Aviso de Privacidad</a>
                            </li>
                        </ul>
                        <div class="d-flex">
                        </div>
                    </div>
                </div>
            </nav>


        </>
    )
}

export default Navbar;

